
  import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
:host {
  display:block;
}

@keyframes fadeIn{
  from{
    opacity:0;
  }
  to{
    opacity:1;
  }
}

.accordion-panel {
  margin-bottom:1.75rem;
  display:flex;
  flex-direction:column;
  border-radius:0.375rem;
  background-color:var(--neutral-white);
  padding-top:0px;
  padding-bottom:0px;
  padding-left:1rem;
  padding-right:1rem;
}

.accordion-panel.active {
  padding-bottom:1rem;
}

.accordion-heading {
  margin:0px;
}

.accordion-button {
  display:flex;
  width:100%;
  cursor:pointer;
  align-items:center;
  justify-content:space-between;
  border-width:0px;
  padding-left:0px;
  padding-right:0px;
  padding-top:1.25rem;
  padding-bottom:1.25rem;
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

@media (min-width: 768px) {

  .accordion-button {
    font-size:var(--fs-2xl);
    line-height:var(--lh-2xl);
  }
}

.accordion-button.active {
  border-width:1px;
}

.accordion-button.active {
  border-bottom-width:2px;
}

.accordion-button.active {
  border-top-width:0px;
}

.accordion-button.active {
  border-right-width:0px;
}

.accordion-button.active {
  border-left-width:0px;
}

.accordion-button.active {
  border-style:solid;
}

.accordion-button .accordion-label {
  text-align:left;
}

.accordion-content ::slotted(p) {
  font-size:var(--fs-base);
  line-height:var(--lh-base);
}

@media (min-width: 768px) {

  .accordion-content ::slotted(p) {
    font-size:var(--fs-lg);
    line-height:var(--lh-lg);
  }
}

.accordion-content[aria-hidden='true'] {
  display:none;
}

.accordion-content[aria-hidden='true'] {
  max-height:0px;
}

.accordion-content[aria-hidden='true'] {
  overflow:hidden;
}

.accordion-content[aria-hidden='true'] {
  opacity:0;
}

.accordion-content[aria-hidden='false']{
    max-height:auto;
    animation:fadeIn 0.3s ease-in;
  }

:host([site='GHS']) .accordion-button {
  background-color:var(--neutral-white);
}

:host([site='GHS']) .accordion-button {
  font-family:var(--ff-display);
}

:host([site='GHS']) .accordion-button {
  font-weight:var(--fw-bold);
}

:host([site='GHS']) .accordion-button {
  line-height:1.25rem;
}

:host([site='GHS']) .accordion-button.active {
  margin-bottom:1rem;
}

:host([site='GHS']) .accordion-button.active {
  border-color:var(--neutral-gray-4);
}

:host([site='GHS']) .accordion-button.active {
  background-color:var(--neutral-white);
}

:host([site='GHS']) .accordion-button.active {
  color:var(--primary-blue-dark);
}

:host([site='GHS']) .accordion-button.inactive {
  color:var(--primary-blue-light-2);
}

:host([site='GHS']) .accordion-button:hover .accordion-label {
  color:var(--primary-blue-dark);
}

:host([site='GHS']) .accordion-content ::slotted(p) {
  font-family:var(--ff-body);
}

:host([site='GHS']) .accordion-content ::slotted(p) {
  color:var(--neutral-gray-1);
}

:host([site='GHS']) .accordion-panel.secondary, :host([site='GHS']) .accordion-panel.tertiary {
  margin-bottom:0px;
}

:host([site='GHS']) .accordion-panel.secondary, :host([site='GHS']) .accordion-panel.tertiary {
  border-width:0px;
}

:host([site='GHS']) .accordion-panel.secondary, :host([site='GHS']) .accordion-panel.tertiary {
  background-color:var(--neutral-transparent);
}

:host([site='GHS']) .accordion-panel.secondary, :host([site='GHS']) .accordion-panel.tertiary {
  padding-left:0px;
}

:host([site='GHS']) .accordion-panel.secondary, :host([site='GHS']) .accordion-panel.tertiary {
  padding-bottom:0px;
}

:host([site='GHS']) .accordion-panel.secondary.active, :host([site='GHS']) .accordion-panel.tertiary.active {
  padding-bottom:0px;
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button, :host([site='GHS']) .accordion-panel.tertiary .accordion-button {
  border-bottom-width:1px;
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button, :host([site='GHS']) .accordion-panel.tertiary .accordion-button {
  border-style:solid;
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button, :host([site='GHS']) .accordion-panel.tertiary .accordion-button {
  background-color:var(--neutral-transparent);
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button.active, :host([site='GHS']) .accordion-panel.tertiary .accordion-button.active {
  border-bottom-width:4px;
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button.active, :host([site='GHS']) .accordion-panel.tertiary .accordion-button.active {
  border-style:solid;
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button.active, :host([site='GHS']) .accordion-panel.tertiary .accordion-button.active {
  background-color:var(--neutral-transparent);
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button.inactive, :host([site='GHS']) .accordion-panel.tertiary .accordion-button.inactive {
  padding-top:1rem;
  padding-bottom:1rem;
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button.inactive > .accordion-content, :host([site='GHS']) .accordion-panel.tertiary .accordion-button.inactive > .accordion-content {
  padding:0px;
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button.active > .accordion-content, :host([site='GHS']) .accordion-panel.tertiary .accordion-button.active > .accordion-content {
  padding:1rem;
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button {
  border-color:var(--neutral-gray-2);
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button.active {
  border-color:var(--primary-blue);
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button.active {
  color:var(--primary-blue-dark);
}

:host([site='GHS']) .accordion-panel.secondary .accordion-button.inactive {
  color:var(--primary-blue-light-2);
}

:host([site='GHS']) .accordion-panel.tertiary .accordion-button {
  border-color:var(--neutral-white);
}

:host([site='GHS']) .accordion-panel.tertiary .accordion-button:hover .accordion-label {
  color:var(--neutral-white);
}

:host([site='GHS']) .accordion-panel.tertiary .accordion-button:hover .accordion-label {
  opacity:0.75;
}

:host([site='GHS']) .accordion-panel.tertiary .accordion-button.active {
  border-color:var(--neutral-white);
}

:host([site='GHS']) .accordion-panel.tertiary .accordion-button.active {
  color:var(--neutral-white);
}

:host([site='GHS']) .accordion-panel.tertiary .accordion-button.inactive {
  color:var(--neutral-white);
}

:host([site='GHS']) .accordion-panel.tertiary .accordion-content ::slotted(p) {
  color:var(--neutral-white);
}

:host([site='BH']) .accordion-panel {
  margin:0px;
}

:host([site='BH']) .accordion-panel {
  border-radius:0px;
}

:host([site='BH']) .accordion-panel {
  border-width:0px;
}

:host([site='BH']) .accordion-panel {
  border-bottom-width:1px;
}

:host([site='BH']) .accordion-panel {
  border-style:solid;
}

:host([site='BH']) .accordion-panel {
  border-color:var(--bh-neutral-default);
}

:host([site='BH']) .accordion-panel {
  background-color:var(--bh-neutral-white);
}

:host([site='BH']) .accordion-panel {
  padding:0px;
}

:host([site='BH']) .accordion-panel {
  color:var(--bh-neutral-darker);
}

:host([site='BH']) .accordion-panel.active {
  border-width:1px;
}

:host([site='BH']) .accordion-button {
  border-style:none;
}

:host([site='BH']) .accordion-button {
  background-color:var(--bh-neutral-white);
}

:host([site='BH']) .accordion-button {
  padding:1rem;
}

:host([site='BH']) .accordion-button {
  font-family:var(--bh-ff-display);
}

:host([site='BH']) .accordion-button {
  font-size:var(--fs-2xl);
  line-height:var(--lh-2xl);
}

:host([site='BH']) .accordion-button {
  color:var(--bh-neutral-darker);
}

@media (min-width: 1024px) {

  :host([site='BH']) .accordion-button {
    font-size:var(--fs-3xl);
    line-height:var(--lh-3xl);
  }
}

:host([site='BH']) .accordion-button:hover, :host([site='BH']) .accordion-button:focus {
  color:var(--bh-brand-primary-default);
}

:host([site='BH']) .accordion-button.active {
  background-color:var(--bh-brand-primary-default);
}

:host([site='BH']) .accordion-button.active {
  color:var(--bh-neutral-white);
}

:host([site='BH']) .accordion-content {
  padding:1.5rem;
}

@media (min-width: 1024px) {

  :host([site='BH']) .accordion-content {
    padding:2rem;
  }
}

:host([site='BH']) .accordion-content ::slotted(*) {
  font-family:var(--bh-ff-body);
}

@media (min-width: 1024px) {

  :host([site='BH']) .sidebar .accordion-button {
    font-size:var(--bh-fs-heading-04);
    line-height:var(--bh-lh-heading-04);
    letter-spacing:var(--bh-ls-heading-04);
  }
}

:host([site='BH']) .sidebar .accordion-content {
  padding:1rem;
}

@media (min-width: 1024px) {

  :host([site='BH']) .sidebar .accordion-content {
    padding:1.5rem;
  }
}

:host([site='BH']) .facets-widget-checkbox {
  position:relative;
}

:host([site='BH']) .facets-widget-checkbox .facets-wrapper {
  margin-top:1rem;
}

:host([site='BH']) .facets-widget-checkbox .facets-wrapper {
  max-height:280px;
}

:host([site='BH']) .facets-widget-checkbox .facets-wrapper {
  overflow-y:auto;
}

:host([site='BH']) .facets-widget-checkbox .facets-wrapper {
  overflow-x:hidden;
}

:host([site='BH']) .facets-widget-checkbox .facets-wrapper {
  padding-top:0px;
  padding-bottom:0px;
}

:host([site='BH']) .facets-widget-checkbox .facets-wrapper::-webkit-scrollbar {
  width:0.5rem;
}

:host([site='BH']) .facets-widget-checkbox .facets-wrapper::-webkit-scrollbar-thumb {
  border-radius:0.25rem;
}

:host([site='BH']) .facets-widget-checkbox .facets-wrapper::-webkit-scrollbar-thumb {
  background-color:var(--bh-brand-primary-dark);
}

:host([site='BH']) .facets-widget-checkbox .form-item {
  margin-bottom:1rem;
}

:host([site='BH']) .facets-widget-checkbox .form-item {
  margin-top:0px;
}

:host([site='BH']) .facets-widget-checkbox .form-item {
  display:flex;
}

:host([site='BH']) .facets-widget-checkbox .form-item {
  vertical-align:middle;
}

:host([site='BH']) .facets-widget-checkbox .form-item:last-child {
  margin-bottom:0px;
}

:host([site='BH']) .facets-widget-checkbox label {
  margin-left:0.5rem;
}

:host([site='BH']) .facets-widget-checkbox input[type='checkbox'] {
  height:1.25rem;
}

:host([site='BH']) .facets-widget-checkbox input[type='checkbox'] {
  width:1.25rem;
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  box-sizing:border-box;
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  width:100%;
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  appearance:none;
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  border-width:1px;
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  border-style:solid;
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  border-color:var(--neutral-gray-2);
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  background-color:var(--neutral-white);
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  padding:0.75rem;
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  font-family:var(--bh-ff-body);
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  font-size:var(--bh-fs-body-01);
  line-height:var(--bh-lh-body-01);
  letter-spacing:var(--bh-ls-body-01);
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  line-height:1.25rem;
}

:host([site='BH']) .facets-widget-checkbox input[type='text'] {
  color:var(--neutral-gray-1);
}

:host([site='BH']) .facets-widget-checkbox input[type='text']{

      border-radius:8px;
    }

:host([site='BH']) .facets-widget-checkbox input[type='text']::placeholder {
  color:var(--neutral-gray-2);
}

:host([site='BH']) .facets-widget-checkbox input[type='text']:hover {
  border-color:var(--tertiary-aqua);
}

:host([site='BH']) .facets-widget-checkbox input[type='text']:hover {
  outline:2px solid transparent;
  outline-offset:2px;
}

:host([site='BH']) .facets-widget-checkbox input[type='text']:focus {
  border-color:var(--tertiary-aqua);
}

:host([site='BH']) .facets-widget-checkbox input[type='text']:focus {
  outline:2px solid transparent;
  outline-offset:2px;
}

:host([site='BH']) .facets-widget-checkbox input[type='text']:focus{
        box-shadow:var(--brand-shadow) !important;
      }

:host([site='BH']) .facets-widget-checkbox input[type='text'].error {
  border-width:1px;
}

:host([site='BH']) .facets-widget-checkbox input[type='text'].error {
  border-color:var(--ui-errorBorder);
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  position:absolute;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  right:0px;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  top:0.25rem;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  margin:0px;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  height:2.5rem;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  width:2.5rem;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  background-color:var(--neutral-transparent);
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  background-position:center;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  background-repeat:no-repeat;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  padding:0px;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  font-size:0px;
}

:host([site='BH']) .facets-widget-checkbox input[type='submit'] {
  --tw-shadow:0 0 #0000;
  --tw-shadow-colored:0 0 #0000;
  box-shadow:0 0 #0000, 0 0 #0000, 0 0 #0000;
  box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

:host([site='BH']) .facets-widget-checkbox input[type='submit']{

      background-size:27px;
      background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='28' height='27' viewBox='0 0 28 27' fill='none'%3E%3Cpath d='M17.9382 15.75H17.0495L16.7345 15.4462C18.0845 13.8712 18.782 11.7225 18.3995 9.43872C17.8707 6.31122 15.2607 3.81372 12.1107 3.43122C7.35195 2.84622 3.34695 6.85122 3.93195 11.61C4.31445 14.76 6.81195 17.37 9.93945 17.8987C12.2232 18.2812 14.372 17.5837 15.947 16.2337L16.2507 16.5487V17.4375L21.032 22.2187C21.4932 22.68 22.247 22.68 22.7082 22.2187C23.1695 21.7575 23.1695 21.0037 22.7082 20.5425L17.9382 15.75ZM11.1882 15.75C8.38695 15.75 6.1257 13.4887 6.1257 10.6875C6.1257 7.88622 8.38695 5.62497 11.1882 5.62497C13.9895 5.62497 16.2507 7.88622 16.2507 10.6875C16.2507 13.4887 13.9895 15.75 11.1882 15.75Z' fill='%23004E7A'/%3E%3C/svg%3E");
    }
`;